import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ThemeToggleFixed } from './ThemeToggle';
import PasswordInput from './PasswordInput';
import { isNativeApp } from '../native/platform';
import './Auth.css';

const backgroundImages = ['/signal-2026-02-01-105917_002.jpeg'];

const SignIn: React.FC = () => {
  // Randomly select an image on component mount
  const [selectedImage, setSelectedImage] = useState<string>('');
  const native = isNativeApp();

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * backgroundImages.length);
    setSelectedImage(backgroundImages[randomIndex]);
  }, []);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(
    () => localStorage.getItem('rememberMe') !== 'false'
  );
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password, native ? true : rememberMe);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <ThemeToggleFixed />
      {/* Background with parallax effect */}
      <div 
        className="auth-background"
        style={{
          filter: 'blur(20px)',
          backgroundImage: selectedImage ? `url(${selectedImage})` : undefined
        }}
      >
        <div className="background-overlay"></div>
      </div>
      
      {/* Fixed content layer */}
      <div className="auth-content-layer">
        <div className="auth-card">
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form" autoComplete="on">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <PasswordInput
              id="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="Enter your password"
              show={showPassword}
              onToggle={() => setShowPassword((prev) => !prev)}
            />
          </div>

          <div className="auth-form-options">
            {!native && (
              <label className="auth-remember-label" htmlFor="remember-me">
                <input
                  type="checkbox"
                  id="remember-me"
                  name="remember"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Remember me
              </label>
            )}
            <Link
              to={
                email.trim()
                  ? `/forgot-password?email=${encodeURIComponent(email.trim())}`
                  : '/forgot-password'
              }
              className="auth-link auth-forgot-link"
            >
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="auth-button"
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div className="auth-footer">
          {!native && (
            <p>
              Don't have an account?{' '}
              <Link to="/signup" className="auth-link">
                Sign up here
              </Link>
            </p>
          )}
          {native ? (
            <p className="auth-link" style={{ color: 'var(--text-secondary)' }}>
              App access is granted by an admin. Most members use the website.
            </p>
          ) : (
            <p>
              <Link to="/" className="auth-link">
                ← Back to Home
              </Link>
            </p>
          )}
        </div>
      </div>
      </div>
    </div>
  );
};

export default SignIn;








